// extracted by mini-css-extract-plugin
export default {"MenuLink":"MenuLink_MenuLink__g2G2h","MenuLinkWrap":"MenuLink_MenuLinkWrap__PNIUx","MenuLinkActive":"MenuLink_MenuLinkActive__du9xp"};